export default __webpack_public_path__ + "static/media/Knight of the Silver Twilight Token.af8d07ca.jpg";